export enum SubProductType {
    Appliance = 'ASS_ELETTRODOMESTICI',
    Implant = 'ASS_IMPIANTI',
    RCDanni = 'ASS_RC_DANNI',
    Utility = 'ASS_PAR_UTILITY',
}
